<template>
  <Modal :open="props.open" @close-modal="$emit('close-modal')">
    <template #modal-header>
      <div>
        <div class="flex items-center">
          <Icon name="Plus" class="w-4 h-4 mr-1 stroke-info" />
          <div class="text-sm font-inter font-semibold text-info">Create</div>
        </div>
        <div class="font-league tracking-[-.56px] font-semibold text-[1.75rem] text-strongest">
          New Beneficial Owner
        </div>
      </div>
    </template>

    <template #modal-body>
      <div class="p-2 lg:p-6">
        <div>
          <TabView
            :tabs="props.modal_config.tabs"
            :activeTab="activeProfileTab"
            @update:activeTab="(key) => (activeProfileTab = key)"
          >
            <template
              v-for="subtab in props.modal_config.tabs"
              :key="subtab.slot_name"
              #[subtab.slot_name]
            >
              <div v-if="props.modal_config.groups?.includes(subtab.label)">
                <Form
                  :schema_array="
                    props.modal_config.schema.filter(
                      (item) => item.record_detail_group === subtab.label
                    )
                  "
                  :state_object="getStateObject(subtab.label)"
                  :record_id="props.modal_config.record_id"
                  variant="secondary"
                />
              </div>
            </template>
          </TabView>
        </div>
      </div>
    </template>
    <template #modal-footer>
      <div class="flex justify-end gap-2">
        <Button @click="$emit('close-modal')" variant="paper-primary" size="sm" class="">
          <template #label>Cancel</template>
        </Button>
        <Button @click="handleConfirm()" variant="primary-grey" size="sm" class="">
          <template #label>Confirm</template>
        </Button>
      </div>
    </template>
  </Modal>
</template>

<script setup>
//IMPORTS
import { ref, watch } from "vue";
import { Modal, TabView, Form, Icon, Button } from "@/components";
import { useCrudStore, useSchemaStore, useDataStore, useUIStore } from "@/stores";
import _ from "lodash";

// STORES
const crudStore = useCrudStore();
const dataStore = useDataStore();
const schemaStore = useSchemaStore();
const UIStore = useUIStore();

// EMITS & PROPS
const emit = defineEmits(["close-modal", "confirm"]);
const props = defineProps({
  open: { type: Boolean, required: true },
  modal_config: { type: Object, required: true },
});

// REFS
const activeProfileTab = ref("personal.personal_information");

// WATCHERS
watch(
  () => props.modal_config.open,
  (is_open) => {
    if (is_open) {
      activeProfileTab.value = props.modal_config.tabs[0].slot_name;
    } else {
      schemaStore.show_input_errors = false;
    }
  },
  { immediate: true }
);

// COMPONENT LOGIC AND FUNCTIONS
async function handleConfirm() {
  try {
    let object = props.modal_config.object_to_edit;
    // object.id_info = props.modal_config.id_info;

    let _continue = schemaStore.validateFields(
      object,
      props.modal_config.schema,
      null,
      true,
      "beneficial_owner"
    );

    if (_continue.proceed) {
      object.user_id = dataStore.contact.user_id;

      object = schemaStore.addCreatedUpdatedFields(object, true, true);

      await crudStore.insert("contacts", [object]);
      await handleActivityLog(true, null);

      //   handle update
      emit("confirm", {
        type: "beneficial_owner",
        record_id: null,
      });

      emit("close-modal");
    } else {
      let invalid_tab = _continue.invalid_groups[0]
        ? props.modal_config.tabs.find((tab) => tab.label === _continue.invalid_groups[0])
        : props.modal_config.tabs[0];

      activeProfileTab.value = invalid_tab.slot_name;
      await handleActivityLog(false, _continue);

      return;
    }
  } catch (e) {
    var alert = {
      type: "error",
      message: `Failed to create beneficial owner.`,
    };
    UIStore.animateNotificationAlert(alert);
    emit("close-modal");
  }
}

function getStateObject(group) {
  if (group == "ID Information") {
    return props.modal_config.object_to_edit.id_info
      ? props.modal_config.object_to_edit.id_info
      : {};
  }
  return props.modal_config.object_to_edit;
}
async function handleActivityLog(valid, validation_details) {
  let status = valid ? "Completed" : "Failed Validation";

  let log = {
    step: "Profile Page",
    substep: "Add Beneficial Owner",
    status: status,
    message: "Adding beneficial owner from all beneficial owners tab",
    url: window.location.href,
    validation_details: valid ? null : JSON.stringify(validation_details),
  };

  log = dataStore.setDefaultFields(log, "investoractivity");
  await crudStore.insert("investoractivity", [log]);
}
</script>
